import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Tag, MessageCircle } from "lucide-react";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-background md:grid md:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden overflow-hidden bg-brand md:flex md:flex-col md:justify-between md:p-12">
        <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-price/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-price/10 blur-3xl" />
        <Link to="/" className="relative flex items-baseline gap-1 font-display">
          <span className="text-2xl font-extrabold text-white">Venda</span>
          <span className="text-xl font-bold text-price-light">Market</span>
        </Link>
        <div className="relative space-y-6">
          <h2 className="font-display text-4xl font-extrabold leading-tight text-white">
            Zambia's marketplace to <span className="text-price-light">buy &amp; sell</span> anything.
          </h2>
          <ul className="space-y-3 text-white/80">
            <li className="flex items-center gap-3"><Tag className="h-5 w-5 text-price-light" /> List an item in under a minute</li>
            <li className="flex items-center gap-3"><MessageCircle className="h-5 w-5 text-price-light" /> Chat &amp; negotiate offers in-app</li>
            <li className="flex items-center gap-3"><ShieldCheck className="h-5 w-5 text-price-light" /> Verified sellers you can trust</li>
          </ul>
        </div>
        <p className="relative text-sm text-white/50">Prices in Kwacha (K) &amp; USD ($)</p>
      </div>

      {/* Form panel */}
      <div className="flex min-h-screen items-center justify-center px-5 py-12">
        <div className="w-full max-w-md animate-fade-up">
          <Link to="/" className="mb-8 flex items-baseline justify-center gap-1 font-display md:hidden">
            <span className="text-2xl font-extrabold text-brand">Venda</span>
            <span className="text-xl font-bold text-price">Market</span>
          </Link>
          <h1 className="font-display text-2xl font-extrabold text-foreground">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-6">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export const inputCls =
  "w-full rounded-xl border border-input bg-white px-4 py-2.5 text-sm outline-none transition focus:border-price focus:ring-2 focus:ring-price/20";
export const labelCls = "mb-1.5 block text-sm font-medium text-foreground";
export const primaryBtn =
  "w-full rounded-xl bg-price py-3 text-sm font-semibold text-white transition hover:bg-price-light disabled:opacity-60";
